import { Textarea, TextareaProps, useMantineColorScheme } from "@mantine/core";
import { useRef } from "react";

interface CustomTextareaProps extends Omit<
  TextareaProps,
  "value" | "onChange"
> {
  readonlyMode: boolean;
  value: string;
  onChange: (value: string) => void;
}

export const CustomTextarea: React.FC<CustomTextareaProps> = ({
  readonlyMode,
  value,
  onChange,
  styles,
  ...rest
}) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const labelColor = isDark ? "#e0e0e0" : "#1a1a1a";

  const handleBlur = () => {
    const v = inputRef.current?.value ?? "";
    onChange(v);
  };

  return (
    <Textarea
      readOnly={readonlyMode}
      ref={inputRef}
      value={value ?? ""}
      onChange={(e) => onChange(e.currentTarget.value)}
      onBlur={handleBlur}
      minRows={4}
      maxRows={4}
      labelProps={{
        fw: 600,
        size: "lg",
        style: { color: labelColor },
      }}
      styles={{
        input: {
          backgroundColor: readonlyMode
            ? isDark
              ? "#2a2a2a"
              : "#f5f5f5"
            : isDark
              ? "#3a3a3a"
              : "white",

          borderColor: readonlyMode
            ? isDark
              ? "#555"
              : "#d0d0d0"
            : isDark
              ? "#4dabf7"
              : "#228be6",

          color: readonlyMode
            ? isDark
              ? "#e0e0e0"
              : "#1a1a1a"
            : isDark
              ? "#fff"
              : "#000",

          cursor: readonlyMode ? "default" : "text",
          transition: "background-color 120ms ease, border-color 120ms ease",
        },
        ...styles,
      }}
      {...rest}
    />
  );
};
